import React, { useState } from 'react';
import { WardsData } from '../../Datas/WardsData';
import IndentModal from '../IndentModal/IndentModal';
import './IndentCards.css';

const IndentCards = () => {
  const [selectedWard, setSelectedWard] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = (ward) => {
    setSelectedWard(ward);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const colors = [
    '#0FA4AF',
    // '#6A5ACD',
    // '#FF6347',
    // '#4CAF50',
    // '#FF9800',
    // '#2196F3',
    // '#FF1493',
    // '#8A2BE2',
  ];

  return (
    <div className="indent-cards-container">
      <h1>Department's Recent Indents</h1>
      <div className="cards-wrapper">
        {WardsData.map((ward, index) => (
          <div
            key={index}
            className="ward-card"
            style={{ backgroundColor: colors[index % colors.length] }}
          >
            <h3>{ward.wardName}</h3>
            <div className=''>Last week</div>
            <button
              onClick={() => handleClick(ward)}
              className="view-meds-btn-dep"
            >
              View Indent
            </button>
          </div>
        ))}
      </div>

      {isModalOpen && selectedWard && (
        <IndentModal selectedWard={selectedWard} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default IndentCards;
